import { SkeletonAvatar, SkeletonAvatarProps } from '@npco/zeller-design-system'

export const SkeletonLoaderAvatar: React.FC<SkeletonAvatarProps> = (props) => {
  return <SkeletonAvatar {...props} />
}
